// extracted by mini-css-extract-plugin
module.exports = {"body":"HorseBook_body__1QiVz","imgBanner":"HorseBook_imgBanner__3WvL8","video":"HorseBook_video__31mMv","panel":"HorseBook_panel__AHh0K"};